import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const OrderForm = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="shadowclass mt-4">
              <div className="row mx-0">
                <h4 className="event-alert"> New Trade Order </h4>
                <div className="col-md-6 px-0 px-sm-3">
                  <ul className="ingredient-info edit-shift">
                    <li>
                      <label className="required">Select Account </label>
                      <div className="input-group select-div mb10">
                        <select
                          name="category_id"
                          className="required"
                          id="IngredientCategoryId"
                        >
                          <option value="">Select</option>
                          <option value="2">Poultry</option>
                          <option value="3">Seafood</option>
                        </select>
                      </div>
                    </li>
                    <li>
                      <label className="required">Supplier Name </label>
                      <div className="input-group mb-2">
                        <input type={"text"} />
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6 px-0 px-sm-3">
                  <ul className="ingredient-info edit-shift">
                    <li>
                      <label className="required">Applicable To </label>
                      <div className="input-group select-div mb-2">
                        <select
                          name="category_id"
                          className="required"
                          id="IngredientCategoryId"
                        >
                          <option value="">Select</option>
                          <option value="2">Poultry</option>
                          <option value="3">Seafood</option>
                        </select>
                      </div>
                    </li>
                    <li>
                      <label className="">Memo </label>
                      <div className="input-group mb-2">
                        <input type={"text"} />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="table-responsive">
                <table className="checklist-table remove-space inventory_table">
                  <thead>
                    <tr>
                      <th> Item ID </th>
                      <th> Category </th>
                      <th> Ingredient Name </th>
                      <th> Expected Amt </th>
                      <th> Units </th>
                      <th> Unit Price </th>
                      <th> Order Quantity </th>
                      <th> Tax Type </th>
                      <th> Sales Tax </th>
                      <th> Total Cost </th>
                      <th> Remarks </th>
                      <th className="action-td"> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="InventoryRow">
                      <td> 1 </td>
                      <td> Dairy</td>
                      <td>Milk</td>
                      <td>133</td>
                      <td>gal</td>
                      <td> $5.00</td>
                      <td className="count-unit">
                        <span className="count_enclosure">
                          <div className="input text required">
                            <input
                              className="order_amount number number_format_ing"
                              type="text"
                            />
                          </div>
                          <a href="#" class="addReason incDecCount" dir="inc">
                            <img src="/img/plus-green.svg" alt="" />
                          </a>
                          <a href="#" class="addReason incDecCount" dir="dec">
                            <img src="/img/minus-green.svg" alt="" />
                          </a>
                        </span>
                      </td>
                      <td>
                        <div className="input-group select-div">
                          <select
                            name="data[OrderItem][1][order_tax_type]"
                            className="required orderTaxType"
                            id="OrderItem1OrderTaxType"
                          >
                            <option value="">Select</option>
                            <option value="gst_registered" selected="selected">
                              GST Registered
                            </option>
                            <option value="non_gst_registered">
                              Non-GST Registered
                            </option>
                            <option value="gst_exempted">GST Exempted</option>
                            <option value="zero_rated">Zero Rated</option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <span className="tax_span">$0.00</span>
                      </td>
                      <td>
                        <span className="total_cost_span">$0.00</span>
                      </td>
                      <td>
                        <div className="input text">
                          <input className="remarks" type="text" />
                        </div>
                      </td>
                      <td className="action-td">
                        <a
                          href="#_"
                          className="circle_icon red remove_single_item"
                        >
                          <i class="iconSprites delete-icon"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="my-3">
                <button className="btn green-btn-revert add-plus" type="button">
                  <i className="i-icon"> </i> Add Order Item
                </button>
              </div>

              <div className="total-price row mx-0">
                <div className="attachment col-md-6 px-0">
                  <ul className="ingredient-info edit-shift">
                    <li>
                      <label>Remarks</label>
                      <div className="input-group col-md-7">
                        <textarea
                          name="data[Invoice][remarks]"
                          className="small_textarea"
                          cols="30"
                          rows="6"
                          id="InvoiceRemarks"
                        ></textarea>
                      </div>
                    </li>
                  </ul>
                  <div className="clear"></div>
                  <br />
                  <br />
                </div>
                <div className="paymentStatus col-md-6">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <b> Sub-Total </b>
                        </td>
                        <td className="align-right">
                          <b>
                            <span id="sub_total">$0.00</span>
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b> Total Item Discounts </b>
                        </td>
                        <td className="align-right">
                          <b>
                            (<span id="total_item_disc">$0.00</span>)
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b> Total Order Discounts </b>
                        </td>
                        <td className="align-right">
                          <a
                            href="javascript:void(0);"
                            className="circle_icon order_discount"
                          >
                            <i className="iconSprites edit-icon"></i>
                          </a>
                          <b>
                            (<span id="total_order_disc">$0.00</span>)
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b> Total Tax </b>
                        </td>
                        <td className="align-right">
                          <b>
                            <span id="total_tax">$0.00</span>
                          </b>
                        </td>
                      </tr>
                      <tr className="grn-txt">
                        <td>
                          <b> Total </b>
                        </td>
                        <td className="align-right">
                          <strong>
                            <span id="grand_total">$0.00</span>
                          </strong>
                        </td>
                      </tr>
                      <tr className="grn-txt">
                        <td colspan="2"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <div class="btn-sec-row clearfix pt-3">
                <button
                  name="submit"
                  type="submit"
                  id="cancel"
                  class="btn cancel"
                >
                  Cancel
                </button>
                <button
                  name="submit"
                  type="submit"
                  id="submit"
                  class="btn bordered-btn mx-2"
                >
                  Save &amp; Back
                </button>
                <button
                  name="submit"
                  type="submit"
                  id="s_submit"
                  class="btn green-btn-revert mx-0"
                >
                  Save &amp; Send
                </button>
              </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default OrderForm;
